"use client";

import { DefaultProps } from "@/app/types/common/DefaultProps";
import { BLOG_CATEGORY_ALL } from "../BlogCategories/BlogCategories.logic";
import BlogArticleCard from "./BlogArticleCard";
import { BLOG_ARTICLES } from "./BlogArticles.logic";
import styles from "./BlogArticles.module.css";

type Props = DefaultProps & {
  activeId: string;
};

export default function BlogArticles(props: Props) {
  const { activeId } = props;
  const lang = props.params.lang;

  const articles =
    activeId === BLOG_CATEGORY_ALL
      ? BLOG_ARTICLES
      : BLOG_ARTICLES.filter((article) => article.categoryId === activeId);

  return (
    <div className={styles.container}>
      {articles.map((article) => (
        <BlogArticleCard key={article.slug[lang]} article={article} lang={lang} />
      ))}
    </div>
  );
}
